/**
 * DeviceGetReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * DeviceGetReq
 */
export interface DeviceGetReq {
  /** 设备ID，逗号分隔 */
  id: string
}

/**
 * DeviceGetReq Schema
 */
export const DeviceGetReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '设备ID，逗号分隔',
      format: 'string',
      type: 'string',
      label: '设备ID',
    },
  },
  required: ['id'],
  type: 'object',
}
